module.exports = __webpack_public_path__ + "static/media/B2.c32d5148.webp";